import React from 'react';
import Modal from '../../../../../components/Modal';
import Tabs from '../../../../../components/Tabs/Tabs';
import TagPreviewMainTabWrap from '../../../../tag/common/tagPreview/tagPreviewMainTab/TagPreviewMainTabWrap';
import TagPreviewDetailPageWrap from '../../../../tag/common/tagPreview/tagPreviewDetailPage/TagPreviewDetailPageWrap';
import './TagPreviewModal.scss';

const PreviewTagDetailModal = (props) => {
  const { isOpen, closeModal, tagDetailLayoutType, changeTagDetailLayoutType, data } = props;
  const { tagPreviewData } = data;
  const { tagInfo, tagViewInfo, tagMainTab, tagDetailPage } = tagPreviewData;

  return (
    <Modal
      title={'태그 미리보기'}
      wrapClassName="preview-tag-detail-modal-wrapper"
      isOpen={isOpen}
      width={377}
      height={700}
      padding={'0px'}
      isFooter={false}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <Tabs
        className="tag-main-tab-item-tabs"
        list={[
          {
            title: '태그 메인 탭',
            content: (
              <TagPreviewMainTabWrap tagName={tagInfo.tagName} tagViewInfo={tagViewInfo} tagMainTab={tagMainTab} />
            ),
          },
          {
            title: '태그 상세',
            content: (
              <TagPreviewDetailPageWrap
                tagName={tagInfo.tagName}
                tagViewInfo={tagViewInfo}
                tagDetailLayoutType={tagDetailLayoutType}
                changeTagDetailLayoutType={changeTagDetailLayoutType}
                tagDetailPage={tagDetailPage}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default PreviewTagDetailModal;
